import BaseModel from '@/store/models/BaseModel';

export default class Media extends BaseModel {}
